import { functionsEmulatorURL } from "src/config/firebase";

type FirestoreConsoleEnv = "prod" | "dev" | "emulator";

function getFirestoreConsoleEnv(): FirestoreConsoleEnv {
  if (functionsEmulatorURL) return "emulator";

  const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID || "";
  if (projectId.includes("dev")) return "dev";
  return "prod";
}

export function firestoreConsoleDocUrl(
  collection: string,
  docId: string
): string | null {
  if (!docId) return null;

  const env = getFirestoreConsoleEnv();
  const encodedCollection = encodeURIComponent(collection);

  if (env === "emulator") {
    return `http://localhost:4000/firestore/default/data/${collection}/${docId}`;
  }

  const projectId = env === "dev" ? "my-reseller-genie-dev" : "myresellergenie";

  return `https://console.firebase.google.com/project/${projectId}/firestore/databases/-default-/data/~2F${encodedCollection}~2F${docId}`;
}

export function formatSlackConsoleLinks(
  alert: {
    id: string;
    user: string;
    integrationId: string | null;
  },
  userEmail: string
) {
  const alertUrl = firestoreConsoleDocUrl("Error_Alerts", alert.id);
  const userUrl = firestoreConsoleDocUrl("Users", alert.user);
  const integrationUrl = alert.integrationId
    ? firestoreConsoleDocUrl("Plaid_Integrations", alert.integrationId)
    : null;

  return {
    alertLine: alertUrl
      ? `alert: ${alert.id} (${alertUrl})`
      : `alert: ${alert.id}`,
    userLine: userUrl
      ? `user: ${userEmail || alert.user} (${userUrl})`
      : `user: ${userEmail || alert.user}`,
    integrationLine: integrationUrl
      ? `integration: ${alert.integrationId} (${integrationUrl})`
      : `integration: ${alert.integrationId || "n/a"}`,
  };
}
